import React from "react";
import { BrowserRouter, NavLink, useLocation, Navigate } from "react-router-dom";
import "@/App.css";

const pages = [
  { path: "/", src: "/pages/signal.html", title: "Signal", testId: "nav-signal" },
  { path: "/learn", src: "/pages/learn.html", title: "Learn", testId: "nav-learn" },
  { path: "/simulate", src: "/pages/paper.html", title: "Paper", testId: "nav-paper" },
  { path: "/playbook", src: "/pages/blog.html", title: "Playbook", testId: "nav-playbook" },
  { path: "/whales", src: "/pages/whales.html", title: "Whales", testId: "nav-whales" },
  { path: "/research", src: "/pages/research.html", title: "Research", testId: "nav-research" },
  { path: "/stocks", src: "/pages/stocks.html", title: "Stocks", testId: "nav-stocks" },
  { path: "/flow", src: "/pages/flow.html", title: "Flow", testId: "nav-flow" },
  { path: "/curator", src: "/pages/curator.html", title: "Curator", testId: "nav-curator" },
  { path: "/ledger", src: "/pages/ledger.html", title: "Ledger", testId: "nav-ledger" },
];

const PageFrames = () => {
  const location = useLocation();

  // Redirect old /blog route to /playbook
  if (location.pathname === "/blog") {
    return <Navigate to="/playbook" replace />;
  }

  return (
    <div className="hikari-content">
      {pages.map((page) => {
        const isActive = location.pathname === page.path;
        return (
          <iframe
            key={page.path}
            src={page.src}
            title={page.title}
            data-testid={`page-frame-${page.title.toLowerCase()}`}
            style={{
              width: "100%",
              height: "calc(100vh - 44px)",
              border: "none",
              display: isActive ? "block" : "none",
            }}
          />
        );
      })}
    </div>
  );
};

const NavBar = () => {
  return (
    <nav className="hikari-nav" data-testid="main-nav">
      <NavLink to="/" className="hikari-brand" data-testid="nav-brand">
        <span className="brand-glyph">+</span>
        <span className="brand-text">
          HIKARI <em>SIGNAL</em>
        </span>
      </NavLink>
      <div className="hikari-links">
        {pages.map((page) => (
          <NavLink
            key={page.path}
            to={page.path}
            end={page.path === "/"}
            className={({ isActive }) =>
              `hikari-link ${isActive ? "active" : ""}`
            }
            data-testid={page.testId}
          >
            {page.title}
          </NavLink>
        ))}
      </div>
    </nav>
  );
};

function App() {
  return (
    <div className="hikari-app" data-testid="hikari-app">
      <BrowserRouter>
        <NavBar />
        <PageFrames />
      </BrowserRouter>
    </div>
  );
}

export default App;
